export const ID_FILTER_SEARCH = 'search';
export const ID_FILTER_CUSTOMER = 'customer';
export const ID_FILTER_CUSTOMER_ID = 'customer-id';
export const ID_FILTER_CUSTOMER_COMPANY_NAME = "customer-company-name"
export const ID_FILTER_INVOICEDATEFROM = 'invoice-date-from';
export const ID_FILTER_INVOICEDATETO = "invoice-date-to";
export const ID_FILTER_STATUS = "statuses";
export const ID_FILTER_LEGAL_ENTITIES = 'legal-entities';
export const ID_FILTER_DEALERS = 'dealers'

export const payableInvoiceDefaultValues = {
    operator: "",
    customerId: "",
    customer: "",
    customerCompanyName: "",
    statuses: [],
    invoiceDateFrom: null,
    invoiceDateTo: null,
    dealers: []   
};